/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AccessGetAccessAuditParams,
  AccessGetEffectiveAccessParams,
  ApiEnvelopeAccessAuditResponse,
  ApiEnvelopeAccessEmptyDto,
  ApiEnvelopeEffectiveAccessResponse,
  ApiEnvelopeResourceAssignmentListResponse,
  ApiEnvelopeRoleDefinitionListResponse,
  GrantResourceAccessRequest,
  SetMainAppAdminVisibilityRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type accessListRolesResponse200 = {
  data: ApiEnvelopeRoleDefinitionListResponse
  status: 200
}

export type accessListRolesResponseSuccess = (accessListRolesResponse200) & {
  headers: Headers;
};
;

export type accessListRolesResponse = (accessListRolesResponseSuccess)

export const getAccessListRolesUrl = () => {




  return `/api/access/roles`
}

export const useAccessListRolesHook = (): ( options?: RequestInit) => Promise<accessListRolesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAccessListRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type accessEnterMemberViewResponse200 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 200
}

export type accessEnterMemberViewResponseSuccess = (accessEnterMemberViewResponse200) & {
  headers: Headers;
};
;

export type accessEnterMemberViewResponse = (accessEnterMemberViewResponseSuccess)

export const getAccessEnterMemberViewUrl = () => {




  return `/api/access/view-mode`
}

export const useAccessEnterMemberViewHook = (): ( options?: RequestInit) => Promise<accessEnterMemberViewResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAccessEnterMemberViewUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type accessLeaveMemberViewResponse200 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 200
}

export type accessLeaveMemberViewResponseSuccess = (accessLeaveMemberViewResponse200) & {
  headers: Headers;
};
;

export type accessLeaveMemberViewResponse = (accessLeaveMemberViewResponseSuccess)

export const getAccessLeaveMemberViewUrl = () => {




  return `/api/access/view-mode`
}

export const useAccessLeaveMemberViewHook = (): ( options?: RequestInit) => Promise<accessLeaveMemberViewResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAccessLeaveMemberViewUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type accessSetMainAppAdminVisibilityResponse200 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 200
}

export type accessSetMainAppAdminVisibilityResponse404 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 404
}

export type accessSetMainAppAdminVisibilityResponseSuccess = (accessSetMainAppAdminVisibilityResponse200) & {
  headers: Headers;
};
export type accessSetMainAppAdminVisibilityResponseError = (accessSetMainAppAdminVisibilityResponse404) & {
  headers: Headers;
};

export type accessSetMainAppAdminVisibilityResponse = (accessSetMainAppAdminVisibilityResponseSuccess | accessSetMainAppAdminVisibilityResponseError)

export const getAccessSetMainAppAdminVisibilityUrl = () => {




  return `/api/access/main-app-admin-visibility`
}

export const useAccessSetMainAppAdminVisibilityHook = (): (setMainAppAdminVisibilityRequest?: SetMainAppAdminVisibilityRequest, options?: RequestInit) => Promise<accessSetMainAppAdminVisibilityResponse> => {

      const customFetcher = useSfetchMutator();
      return (setMainAppAdminVisibilityRequest?: SetMainAppAdminVisibilityRequest, options?: RequestInit) => {

        return customFetcher(getAccessSetMainAppAdminVisibilityUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setMainAppAdminVisibilityRequest)
  }
);
      }
  }


export type accessGetAssignmentsResponse200 = {
  data: ApiEnvelopeResourceAssignmentListResponse
  status: 200
}

export type accessGetAssignmentsResponse403 = {
  data: ApiEnvelopeResourceAssignmentListResponse
  status: 403
}

export type accessGetAssignmentsResponse404 = {
  data: ApiEnvelopeResourceAssignmentListResponse
  status: 404
}

export type accessGetAssignmentsResponseSuccess = (accessGetAssignmentsResponse200) & {
  headers: Headers;
};
export type accessGetAssignmentsResponseError = (accessGetAssignmentsResponse403 | accessGetAssignmentsResponse404) & {
  headers: Headers;
};

export type accessGetAssignmentsResponse = (accessGetAssignmentsResponseSuccess | accessGetAssignmentsResponseError)

export const getAccessGetAssignmentsUrl = (id: string,) => {




  return `/api/access/resources/${id}/assignments`
}

export const useAccessGetAssignmentsHook = (): (id: string, options?: RequestInit) => Promise<accessGetAssignmentsResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getAccessGetAssignmentsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type accessGrantAccessResponse200 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 200
}

export type accessGrantAccessResponse400 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 400
}

export type accessGrantAccessResponse403 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 403
}

export type accessGrantAccessResponse404 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 404
}

export type accessGrantAccessResponseSuccess = (accessGrantAccessResponse200) & {
  headers: Headers;
};
export type accessGrantAccessResponseError = (accessGrantAccessResponse400 | accessGrantAccessResponse403 | accessGrantAccessResponse404) & {
  headers: Headers;
};

export type accessGrantAccessResponse = (accessGrantAccessResponseSuccess | accessGrantAccessResponseError)

export const getAccessGrantAccessUrl = (id: string,) => {




  return `/api/access/resources/${id}/assignments`
}

export const useAccessGrantAccessHook = (): (id: string,
    grantResourceAccessRequest?: GrantResourceAccessRequest, options?: RequestInit) => Promise<accessGrantAccessResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    grantResourceAccessRequest?: GrantResourceAccessRequest, options?: RequestInit) => {

        return customFetcher(getAccessGrantAccessUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantResourceAccessRequest)
  }
);
      }
  }


export type accessRevokeAccessResponse200 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 200
}

export type accessRevokeAccessResponse400 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 400
}

export type accessRevokeAccessResponse403 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 403
}

export type accessRevokeAccessResponse404 = {
  data: ApiEnvelopeAccessEmptyDto
  status: 404
}

export type accessRevokeAccessResponseSuccess = (accessRevokeAccessResponse200) & {
  headers: Headers;
};
export type accessRevokeAccessResponseError = (accessRevokeAccessResponse400 | accessRevokeAccessResponse403 | accessRevokeAccessResponse404) & {
  headers: Headers;
};

export type accessRevokeAccessResponse = (accessRevokeAccessResponseSuccess | accessRevokeAccessResponseError)

export const getAccessRevokeAccessUrl = (id: string,
    assignmentId: string,) => {




  return `/api/access/resources/${id}/assignments/${assignmentId}`
}

export const useAccessRevokeAccessHook = (): (id: string,
    assignmentId: string, options?: RequestInit) => Promise<accessRevokeAccessResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    assignmentId: string, options?: RequestInit) => {

        return customFetcher(getAccessRevokeAccessUrl(id,assignmentId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type accessGetEffectiveAccessResponse200 = {
  data: ApiEnvelopeEffectiveAccessResponse
  status: 200
}

export type accessGetEffectiveAccessResponse403 = {
  data: ApiEnvelopeEffectiveAccessResponse
  status: 403
}

export type accessGetEffectiveAccessResponse404 = {
  data: ApiEnvelopeEffectiveAccessResponse
  status: 404
}

export type accessGetEffectiveAccessResponseSuccess = (accessGetEffectiveAccessResponse200) & {
  headers: Headers;
};
export type accessGetEffectiveAccessResponseError = (accessGetEffectiveAccessResponse403 | accessGetEffectiveAccessResponse404) & {
  headers: Headers;
};

export type accessGetEffectiveAccessResponse = (accessGetEffectiveAccessResponseSuccess | accessGetEffectiveAccessResponseError)

export const getAccessGetEffectiveAccessUrl = (id: string,
    params?: AccessGetEffectiveAccessParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/access/resources/${id}/effective?${stringifiedParams}` : `/api/access/resources/${id}/effective`
}

export const useAccessGetEffectiveAccessHook = (): (id: string,
    params?: AccessGetEffectiveAccessParams, options?: RequestInit) => Promise<accessGetEffectiveAccessResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: AccessGetEffectiveAccessParams, options?: RequestInit) => {

        return customFetcher(getAccessGetEffectiveAccessUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type accessGetAccessAuditResponse200 = {
  data: ApiEnvelopeAccessAuditResponse
  status: 200
}

export type accessGetAccessAuditResponse403 = {
  data: ApiEnvelopeAccessAuditResponse
  status: 403
}

export type accessGetAccessAuditResponse404 = {
  data: ApiEnvelopeAccessAuditResponse
  status: 404
}

export type accessGetAccessAuditResponseSuccess = (accessGetAccessAuditResponse200) & {
  headers: Headers;
};
export type accessGetAccessAuditResponseError = (accessGetAccessAuditResponse403 | accessGetAccessAuditResponse404) & {
  headers: Headers;
};

export type accessGetAccessAuditResponse = (accessGetAccessAuditResponseSuccess | accessGetAccessAuditResponseError)

export const getAccessGetAccessAuditUrl = (id: string,
    params?: AccessGetAccessAuditParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/access/resources/${id}/audit?${stringifiedParams}` : `/api/access/resources/${id}/audit`
}

export const useAccessGetAccessAuditHook = (): (id: string,
    params?: AccessGetAccessAuditParams, options?: RequestInit) => Promise<accessGetAccessAuditResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: AccessGetAccessAuditParams, options?: RequestInit) => {

        return customFetcher(getAccessGetAccessAuditUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


